import { $t } from '@/utils/languageAuto';

var render = function () {
  var this$1 = this;

  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('div', {
    staticClass: "mb-10 my-page-tip-box ant-alert ant-alert-warning"
  }, [_c('div', [_vm._v($t("\u5F00\u7968\u8BF4\u660E\uFF1A"))]), _c('div', [_vm._v($t("\u2460\u8D26\u53F7\u5BA1\u6838\u901A\u8FC7\u540E\uFF0C\u7CFB\u7EDF\u4F1A\u81EA\u52A8\u83B7\u53D6\u7A0E\u53F7\u53CA\u5730\u5740\u7EF4\u62A4\u5F00\u7968\u8D44\u6599\uFF0C\u60A8\u53EF\u8FDB\u5165")), _c('a-button', {
    staticStyle: {
      "height": "22px",
      "padding": "0"
    },
    attrs: {
      "type": "link",
      "fbu-analyse-name": $t("\u3010\u5F00\u7968\u8D44\u6599\u7EF4\u62A4\u3011")
    },
    on: {
      "click": _vm.handleToBillDataPage
    }
  }, [_vm._v($t("\u3010\u5F00\u7968\u8D44\u6599\u7EF4\u62A4\u3011"))]), _vm._v($t("\u9875\u9762\u6838\u5BF9\u5E76\u4FEE\u6539\uFF1B"))], 1), _c('div', [_vm._v($t("\u2461\u82E5\u8D26\u5355\u5DF2\u8FBE\u5BF9\u5E94\u6D77\u5916\u4E3B\u4F53\u7684\u5F00\u7968\u9650\u671F\uFF08\u5373\u5F00\u7968\u65F6\u6548\uFF09\uFF0C\u672A\u63D0\u4EA4\u6709\u6548\u5F00\u7968\u7533\u8BF7\uFF0C\u7CFB\u7EDF\u5C06\u81EA\u52A8\u89E6\u53D1\u5F00\u7968\u7533\u8BF7\uFF0C\u65E0\u9700\u60A8\u624B\u52A8\u64CD\u4F5C\u3002\u5404\u6D77\u5916\u4E3B\u4F53\u56FD\u5BB6\u5F00\u7968\u671F\u9650\u89C4\u5219\uFF0C")), _c('a-button', {
    staticStyle: {
      "height": "22px",
      "padding": "0"
    },
    attrs: {
      "type": "link",
      "fbu-analyse-name": $t("\u8BE6\u89C1>")
    },
    on: {
      "click": _vm.handleShowBillingDeadlineRule
    }
  }, [_vm._v($t("\u8BE6\u89C1>"))]), _vm._v("。")], 1), _c('div', [_vm._v($t("\u2462\u82E5\u60A8\u9047\u5230\u5BA2\u6237\u7AEF\u65E0\u6CD5\u53D1\u8D77\u5F00\u7968\u7533\u8BF7\u7684\u60C5\u51B5\uFF0C\u8BF7\u76F4\u63A5\u8054\u7CFB\u4E13\u5C5E\u9500\u552E\u7ECF\u7406\u6216\u5BA2\u670D\u56E2\u961F\uFF0C\u6211\u4EEC\u5C06\u4E3A\u60A8\u63D0\u4F9B\u7EBF\u4E0B\u5F00\u7968\u534F\u52A9\u3002\u5F00\u7968\u5B8C\u6210\u540E\uFF0C\u7CFB\u7EDF\u5C06\u81EA\u52A8\u5173\u8054\u8D26\u5355\u5E76\u4E0A\u4F20\u81F3\u5BA2\u6237\u7AEF\u3002\u60A8\u53EF\u901A\u8FC7")), _c('a-button', {
    staticStyle: {
      "height": "22px",
      "padding": "0"
    },
    attrs: {
      "type": "link",
      "fbu-analyse-name": $t("\u3010\u53D1\u7968\u7BA1\u7406\u3011")
    },
    on: {
      "click": _vm.handleToInvoicePage
    }
  }, [_vm._v($t("\u3010\u53D1\u7968\u7BA1\u7406\u3011"))]), _vm._v($t("\u9875\u9762\u5B9E\u65F6\u67E5\u8BE2\u53D1\u7968\u72B6\u6001\u3002"))], 1)]), _c('tip'), _c('my-enter-search', {
    on: {
      "search": _vm.handleSearch
    }
  }, [_c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "allow-clear": false,
      "data-permission": "finance_reconciliation_list_code_type",
      "id": "finance_reconciliation_list_code_type"
    },
    model: {
      value: _vm.searchData.code_field,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "code_field", $$v);
      },
      expression: "searchData.code_field"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": "bill_number"
    }
  }, [_vm._v(_vm._s(_vm.t('账单号')))])], 1), _c('a-input', {
    staticClass: "form-item-input",
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "allowClear": "",
      "maxLength": 100,
      "data-permission": "finance_reconciliation_list_code_value",
      "id": "finance_reconciliation_list_code_value"
    },
    model: {
      value: _vm.searchData.code_value,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "code_value", $$v);
      },
      expression: "searchData.code_value"
    }
  })], 1), _c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-analyse-name": $t("\u8D26\u6237\u7F16\u7801"),
      "show-tip": "",
      "show-search": "",
      "data-permission": "finance_reconciliation_list_account_code",
      "id": "finance_reconciliation_list_account_code",
      "placeholder": _vm.t('账户编码'),
      "allowClear": ""
    },
    model: {
      value: _vm.searchData.account_code,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "account_code", $$v);
      },
      expression: "searchData.account_code"
    }
  }, _vm._l(_vm.accountList, function (item) {
    return _c('a-select-option', {
      key: item.account_code
    }, [_vm._v(_vm._s(item.account_code))]);
  }), 1), _c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-analyse-name": $t("\u8D26\u5355\u786E\u8BA4\u7ED3\u679C"),
      "show-tip": "",
      "data-permission": "finance_reconciliation_list_confirm_result",
      "id": "finance_reconciliation_list_confirm_result",
      "placeholder": _vm.t('账单确认结果'),
      "allowClear": ""
    },
    model: {
      value: _vm.searchData.reconciliation_result,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "reconciliation_result", $$v);
      },
      expression: "searchData.reconciliation_result"
    }
  }, _vm._l(_vm.checkResultsData, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))]);
  }), 1), _c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-analyse-name": $t("\u8D26\u5355\u786E\u8BA4\u72B6\u6001"),
      "data-permission": "finance_reconciliation_list_confirm_status",
      "id": "finance_reconciliation_list_confirm_status",
      "show-tip": "",
      "placeholder": _vm.t('账单确认状态'),
      "allowClear": ""
    },
    model: {
      value: _vm.searchData.reconciliation_status,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "reconciliation_status", $$v);
      },
      expression: "searchData.reconciliation_status"
    }
  }, _vm._l(_vm.checkStateData, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))]);
  }), 1), _c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-analyse-name": $t("\u5904\u7406\u72B6\u6001"),
      "show-tip": "",
      "data-permission": "finance_reconciliation_list_process_status",
      "id": "finance_reconciliation_list_process_status",
      "placeholder": _vm.t('处理状态'),
      "allowClear": ""
    },
    model: {
      value: _vm.searchData.handler_status,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "handler_status", $$v);
      },
      expression: "searchData.handler_status"
    }
  }, _vm._l(_vm.treatmentStateData, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))]);
  }), 1), _c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-analyse-name": $t("\u56DE\u6267\u72B6\u6001"),
      "placeholder": _vm.t('回执状态'),
      "data-permission": "finance_reconciliation_list_receipt_status",
      "id": "finance_reconciliation_list_receipt_status",
      "show-tip": "",
      "allowClear": ""
    },
    model: {
      value: _vm.searchData.reply_status,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "reply_status", $$v);
      },
      expression: "searchData.reply_status"
    }
  }, _vm._l(_vm.returnReceiptStateData, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))]);
  }), 1), _c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-analyse-name": $t("\u53D1\u7968\u72B6\u6001"),
      "data-permission": "finance_reconciliation_list_invoice_status",
      "id": "finance_reconciliation_list_invoice_status",
      "show-tip": "",
      "placeholder": _vm.t('发票状态'),
      "allowClear": ""
    },
    model: {
      value: _vm.searchData.invoice_state,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "invoice_state", $$v);
      },
      expression: "searchData.invoice_state"
    }
  }, _vm._l(_vm.invoiceStateData, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))]);
  }), 1), _c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-analyse-name": $t("\u786E\u8BA4\u65B9\u5F0F"),
      "show-tip": "",
      "data-permission": "finance_reconciliation_list_confirm_way",
      "id": "finance_reconciliation_list_confirm_way",
      "placeholder": _vm.t('确认方式'),
      "allowClear": ""
    },
    model: {
      value: _vm.searchData.confirm_type,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "confirm_type", $$v);
      },
      expression: "searchData.confirm_type"
    }
  }, _vm._l(_vm.confirmWayData, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))]);
  }), 1)], 1), _c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "allow-clear": false,
      "value": "1",
      "data-permission": "finance_reconciliation_list_time_type",
      "id": "finance_reconciliation_list_time_type"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v(_vm._s(_vm.t('账单周期')))])], 1), _c('my-range-picker', {
    attrs: {
      "placeholder": [_vm.t('开始'), _vm.t('结束')],
      "format": "YYYY/MM/DD",
      "data-permission": "finance_reconciliation_list_time_value",
      "id": "finance_reconciliation_list_time_value"
    },
    model: {
      value: _vm.datetimeDefaultValue,
      callback: function ($$v) {
        _vm.datetimeDefaultValue = $$v;
      },
      expression: "datetimeDefaultValue"
    }
  }, [_c('a-icon', {
    attrs: {
      "slot": "suffixIcon",
      "type": "calendar"
    },
    slot: "suffixIcon"
  })], 1)], 1), _c('span', {
    staticStyle: {
      "vertical-align": "bottom"
    }
  }, [_c('a-button', {
    attrs: {
      "ghost": "",
      "type": "primary",
      "data-sign": "finance_reconciliation_bill_query",
      "data-permission": "finance_reconciliation_list_search",
      "id": "finance_reconciliation_list_search",
      "fbu-analyse-name": $t("\u641C\u7D22")
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "search"
    }
  }), _vm._v(" " + _vm._s(_vm.t('搜索')) + " ")], 1), _c('a-button', {
    staticClass: "ml-10",
    attrs: {
      "data-sign": "finance_reconciliation_bill_reset",
      "data-permission": "finance_reconciliation_list_reset",
      "id": "finance_reconciliation_list_reset",
      "fbu-analyse-name": $t("\u91CD\u7F6E")
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_vm._v(_vm._s(_vm.t('重置')))])], 1)], 1), _c('div', {
    staticClass: "mt-15 handle-cont"
  }, [_c('span', [_vm._v(_vm._s(_vm.t('已选')) + _vm._s(_vm.t('common', ':')) + " " + _vm._s(_vm.selectedList.length))]), _c('a-dropdown', {
    directives: [{
      name: "permission",
      rawName: "v-permission",
      value: 'finance_reconciliation_export',
      expression: "'finance_reconciliation_export'"
    }]
  }, [_c('a-menu', {
    attrs: {
      "slot": "overlay"
    },
    slot: "overlay"
  }, [_c('a-menu-item', {
    key: "1",
    attrs: {
      "data-sign": "finance_reconciliation_bill_export_all",
      "fbu-analyse-name": $t("\u5BFC\u51FA\u5168\u90E8")
    },
    on: {
      "click": function ($event) {
        return _vm.handleExport(true);
      }
    }
  }, [_vm._v(_vm._s(_vm.t('导出全部')))]), _c('a-menu-item', {
    key: "2",
    attrs: {
      "data-sign": "finance_reconciliation_bill_export_selected",
      "fbu-analyse-name": $t("\u5BFC\u51FA\u5DF2\u9009")
    },
    on: {
      "click": function ($event) {
        return _vm.handleExport(false);
      }
    }
  }, [_vm._v(_vm._s(_vm.t('导出已选')))])], 1), _c('a-button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "fbu-analyse-name": $t("\u5BFC\u51FA")
    }
  }, [_vm._v(" " + _vm._s(_vm.t('导出')) + " "), _c('a-icon', {
    attrs: {
      "type": "down"
    }
  })], 1)], 1), _c('a-button', {
    directives: [{
      name: "permission",
      rawName: "v-permission",
      value: 'finance_reconciliation_apply',
      expression: "'finance_reconciliation_apply'"
    }],
    staticClass: "ml-10",
    attrs: {
      "data-sign": "finance_reconciliation_bill_apply",
      "data-permission": "finance_reconciliation_list_apply",
      "id": "finance_reconciliation_list_apply",
      "fbu-analyse-name": $t("\u7533\u8BF7\u5F00\u7968")
    },
    on: {
      "click": function ($event) {
        return _vm.handleApplyInvoice(true);
      }
    }
  }, [_vm._v(_vm._s(_vm.t('申请开票')))]), _c('span', {
    staticStyle: {
      "margin-left": "8px",
      "color": "#FF0000"
    }
  }, [_vm._v(_vm._s(_vm.t('开票申请步骤：需先确认账单，确认后勾选发起开票申请')))])], 1), _c('div', {
    staticClass: "tableContent"
  }, [_c('a-skeleton', {
    attrs: {
      "active": "",
      "loading": _vm.loadingStatus
    }
  }, [_c('my-table', {
    staticClass: "box min-ptext",
    attrs: {
      "bordered": "",
      "is-filter-box": "",
      "data-sign": "finance_reconciliation_bill_list",
      "fixed-header": "",
      "useMouseTool": "",
      "columns": _vm.columns,
      "data-source": _vm.dataList,
      "name": "reconciliationList",
      "row-key": "reconciliation_id",
      "row-selection": _vm.rowSelection,
      "pagination": false
    },
    scopedSlots: _vm._u([{
      key: "reconciliationNumbers",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [_c('router-link', {
          directives: [{
            name: "copy2",
            rawName: "v-copy2",
            value: record.reconciliation_number,
            expression: "record.reconciliation_number"
          }],
          attrs: {
            "to": {
              name: 'ReconciliationBillDetailPage',
              query: {
                id: record.reconciliation_id,
                number: record.reconciliation_number
              }
            }
          }
        }, [_vm._v(_vm._s(record.reconciliation_number))]), _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: record.is_has_invoice,
            expression: "record.is_has_invoice"
          }]
        }, [_c('a-popover', [_c('div', {
          attrs: {
            "slot": "content"
          },
          slot: "content"
        }, [_vm._v(_vm._s(_vm.t('已开发票')))]), _c('a-icon', {
          attrs: {
            "type": "money-collect"
          }
        })], 1)], 1)], 1);
      }
    }, {
      key: "billNumbers",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {
          directives: [{
            name: "copy2",
            rawName: "v-copy2",
            value: record.bill_number_list || '',
            expression: "record.bill_number_list || ''"
          }],
          staticStyle: {
            "display": "inline-block"
          }
        }, _vm._l(record.bill_number_list, function (item, key) {
          return _c('p', {
            key: key
          }, [_c('router-link', {
            directives: [{
              name: "copy2",
              rawName: "v-copy2",
              value: item,
              expression: "item"
            }],
            attrs: {
              "to": {
                name: 'ReconciliationBillDetailPage',
                query: {
                  id: record.reconciliation_id,
                  number: record.reconciliation_number
                }
              }
            }
          }, [_vm._v(_vm._s(item))])], 1);
        }), 0);
      }
    }, {
      key: "signBody",
      fn: function (ref) {
        var record = ref.record;
        return [_c('div', {
          staticClass: "code-box"
        }, [_c('span', {
          staticClass: "code-label"
        }, [_vm._v(_vm._s(_vm.t("账户编号")) + _vm._s(_vm.t('common', ':')))]), _c('span', {
          directives: [{
            name: "copy2",
            rawName: "v-copy2",
            value: record.sign_body_info.account_code,
            expression: "record.sign_body_info.account_code"
          }],
          staticClass: "code-content"
        }, [_vm._v(_vm._s(record.sign_body_info.account_code))])]), _c('div', {
          staticClass: "code-box"
        }, [_c('span', {
          staticClass: "code-label"
        }, [_vm._v(_vm._s(_vm.t("签约主体")) + _vm._s(_vm.t('common', ':')))]), _c('span', {
          directives: [{
            name: "copy2",
            rawName: "v-copy2",
            value: record.sign_body_info.sign_body_name,
            expression: "record.sign_body_info.sign_body_name"
          }],
          staticClass: "code-content"
        }, [_vm._v(_vm._s(record.sign_body_info.sign_body_name))])]), _c('div', {
          staticClass: "code-box"
        }, [_c('span', {
          staticClass: "code-label"
        }, [_vm._v(_vm._s(_vm.t("服务主体")) + _vm._s(_vm.t('common', ':')))]), _c('span', {
          directives: [{
            name: "copy2",
            rawName: "v-copy2",
            value: record.sign_body_info.service_body_name,
            expression: "record.sign_body_info.service_body_name"
          }],
          staticClass: "code-content"
        }, [_vm._v(_vm._s(record.sign_body_info.service_body_name))])]), _c('div', {
          staticClass: "code-box"
        }, [_c('span', {
          staticClass: "code-label"
        }, [_vm._v(_vm._s(_vm.t("签约业务")) + _vm._s(_vm.t('common', ':')))]), _c('span', {
          staticClass: "code-content"
        }, [_vm._v(_vm._s(record.sign_body_info.sign_business_type_text))])])];
      }
    }, {
      key: "startBalances",
      fn: function (ref) {
        var record = ref.record;
        return _vm._l(record.start_balance, function (item, index) {
          return _c('p', {
            key: index
          }, [_c('money-format', {
            attrs: {
              "num": item.currency_value,
              "currency": item.currency_code,
              "formatter": true
            }
          })], 1);
        });
      }
    }, {
      key: "endBalances",
      fn: function (ref) {
        var record = ref.record;
        return _vm._l(record.end_balance, function (item, index) {
          return _c('p', {
            key: index
          }, [_c('money-format', {
            attrs: {
              "num": item.currency_value,
              "currency": item.currency_code,
              "formatter": true
            }
          })], 1);
        });
      }
    }, {
      key: "billTime",
      fn: function (ref) {
        var record = ref.record;
        return [_c('p', [_vm._v(_vm._s(record.bill_from_time) + " " + _vm._s(_vm.t("至")) + " " + _vm._s(record.bill_to_time))])];
      }
    }, {
      key: "allTotal",
      fn: function (ref) {
        var record = ref.record;
        return _vm._l(record.all_total, function (item, index) {
          return _c('p', {
            key: index
          }, [_c('money-format', {
            attrs: {
              "num": item.currency_value,
              "currency": item.currency_code,
              "formatter": true
            }
          })], 1);
        });
      }
    }, {
      key: "nonInvoiceableAmountList",
      fn: function (ref) {
        var record = ref.record;
        return _vm._l(record.non_invoiceable_amount_list, function (item, index) {
          return _c('p', {
            key: index
          }, [_c('money-format', {
            attrs: {
              "num": item.currency_value,
              "currency": item.currency_code,
              "formatter": true
            }
          })], 1);
        });
      }
    }, {
      key: "pendingAmountList",
      fn: function (ref) {
        var record = ref.record;
        return _vm._l(record.pending_amount_list, function (item, index) {
          return _c('p', {
            key: index
          }, [_c('money-format', {
            attrs: {
              "num": item.currency_value,
              "currency": item.currency_code,
              "formatter": true
            }
          })], 1);
        });
      }
    }, {
      key: "confirmResult",
      fn: function (ref) {
        var record = ref.record;
        return [_vm._v(" " + _vm._s(_vm._f("filterEmpty")(record.confirm_result_type_text)) + " "), record.handler_status === _vm.$enum.finance.HandlerStatusEnum.PROCESSED ? _c('span', [_c('a-popover', [_c('div', {
          attrs: {
            "slot": "content"
          },
          slot: "content"
        }, [_vm._v(_vm._s(_vm.t('已处理')))]), _c('a-icon', {
          style: {
            fontsize: '18px',
            color: '#8bde1a'
          },
          attrs: {
            "type": "check-circle",
            "theme": "filled"
          }
        })], 1)], 1) : record.handler_status === _vm.$enum.finance.HandlerStatusEnum.PENDING ? _c('span', [_c('a-popover', [_c('div', {
          attrs: {
            "slot": "content"
          },
          slot: "content"
        }, [_vm._v(_vm._s(_vm.t('未处理')))]), _c('a-icon', {
          style: {
            fontsize: '18px',
            color: '#FF7E00'
          },
          attrs: {
            "type": "exclamation-circle",
            "theme": "filled"
          }
        })], 1)], 1) : _vm._e()];
      }
    }, {
      key: "reconciliationStatus",
      fn: function (ref) {
        var record = ref.record;
        return [_vm._v(" " + _vm._s(record.reconciliation_status_text) + " "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: record.reconciliation_status === _vm.$enum.finance.ReconciliationStatusEnum.CONFIRMED || record.reconciliation_status === _vm.$enum.finance.ReconciliationStatusEnum.AUDIT_PENDING,
            expression: "record.reconciliation_status === $enum.finance.ReconciliationStatusEnum.CONFIRMED  || record.reconciliation_status === $enum.finance.ReconciliationStatusEnum.AUDIT_PENDING"
          }]
        }, [record.reply_status ? _c('a-popover', [_c('div', {
          attrs: {
            "slot": "content"
          },
          slot: "content"
        }, [_vm._v(_vm._s(_vm.t('已上传对账函')))]), _c('a-icon', {
          attrs: {
            "type": "paper-clip"
          }
        })], 1) : _vm._e()], 1), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: record.reconciliation_status === _vm.$enum.finance.ReconciliationStatusEnum.REJECTED,
            expression: "record.reconciliation_status === $enum.finance.ReconciliationStatusEnum.REJECTED"
          }]
        }, [record.audit_remark ? _c('a-popover', [_c('div', {
          attrs: {
            "slot": "content"
          },
          slot: "content"
        }, [_vm._v(_vm._s(record.audit_remark))]), _c('a-icon', {
          attrs: {
            "type": "question-circle"
          }
        })], 1) : _vm._e()], 1)];
      }
    }, {
      key: "operation",
      fn: function (ref) {
        var record = ref.record;
        return _c('my-operation', {}, [record.reconciliation_status == _vm.$enum.finance.ReconciliationStatusEnum.CONFIRM_PENDING || record.reconciliation_status == _vm.$enum.finance.ReconciliationStatusEnum.REJECTED ? _c('router-link', {
          directives: [{
            name: "permission",
            rawName: "v-permission",
            value: 'finance_reconciliation_confirm',
            expression: "'finance_reconciliation_confirm'"
          }],
          attrs: {
            "data-sign": "finance_reconciliation_bill_confirm",
            "to": {
              name: 'ReconciliationBillConfirmPage',
              query: {
                id: record.reconciliation_id,
                number: record.reconciliation_number
              }
            }
          }
        }, [_vm._v(_vm._s(_vm.t('确认')))]) : _vm._e()], 1);
      }
    }])
  })], 1)], 1), _c('div', {
    staticClass: "pagination-box"
  }, [_c('my-pagination', {
    attrs: {
      "total": _vm.total,
      "isFixed": "",
      "name": "reconciliationList",
      "page-size": _vm.searchData.page_size
    },
    on: {
      "update:pageSize": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "update:page-size": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "onChange": _vm.handlePageChange
    },
    model: {
      value: _vm.searchData.page_index,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "page_index", $$v);
      },
      expression: "searchData.page_index"
    }
  })], 1), _c('apply-invoice', {
    ref: "applyInvoiceRef",
    attrs: {
      "data": _vm.selectedListItem
    },
    on: {
      "success": _vm.handleApplyInvoiceSuccess
    }
  }), _c('billing-deadline-rule', {
    ref: "billingDeadlineRuleRef"
  }), _c('div', [_c('my-modal', {
    attrs: {
      "data-sign": "finance_reconciliation_bill_apply_success_modal",
      "title": _vm.t('申请开票')
    },
    on: {
      "ok": function () {
        this$1.applyInvoiceSuccess = false;
      }
    },
    model: {
      value: _vm.applyInvoiceSuccess,
      callback: function ($$v) {
        _vm.applyInvoiceSuccess = $$v;
      },
      expression: "applyInvoiceSuccess"
    }
  }, [_c('div', {
    staticClass: "success-content"
  }, [_c('div', {
    staticClass: "pt-15 main-text"
  }, [_vm._v(_vm._s(_vm.t('您的开票申请已成功提交')))]), _c('div', {
    staticClass: "mt-15"
  }, [_c('span', {
    staticClass: "tips"
  }, [_vm._v(_vm._s(_vm.t('开票结果请及时关注 ')))]), _c('a', {
    staticClass: "link",
    attrs: {
      "data-sign": "finance_reconciliation_bill_apply_success_redirect",
      "href": "javascript:;",
      "fbu-analyse-name": $t("\u53D1\u7968\u7BA1\u7406")
    },
    on: {
      "click": _vm.handleToInvoicePage
    }
  }, [_vm._v(_vm._s(_vm.t('发票管理')))])])])])], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };